import React, { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import styles from './PermissionsHome.style.v2';
import SearchUsers from '../SearchUsers';
import SearchRoles from '../SearchRoles';

const PermissionsHome = () => {
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState('roles');

  useEffect(() => {
    if (pathname.includes('/users')) {
      setSelectedKey('users');
    } else {
      setSelectedKey('roles');
    }
  }, [pathname]);

  return (
    <>
      <PageTitle>Permissions</PageTitle>

      <Main>
        <Pivot
          className={styles.tabs}
          aria-label="Permissions"
          linkSize={PivotLinkSize.large}
          selectedKey={selectedKey}
          onLinkClick={item => {
            history.push(item.props.href);
          }}
        >
          <PivotItem headerText="Role Management" itemKey="roles" href={`${url}/roles`} />
          <PivotItem headerText="User Management" itemKey="users" href={`${url}/users`} />
        </Pivot>

        <Switch>
          <Route exact path={`${path}/roles`} component={SearchRoles} />
          <Route exact path={`${path}/users`} component={SearchUsers} />
        </Switch>
      </Main>
    </>
  );
};

export default PermissionsHome;
